import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditUsers from './EditUsers'
import ListUsers from './ListUsers'
import NewUsers from './NewUsers'

const AdminUsersRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListUsers /></PrivateRoute7>} />
        <Route path="edit-user" element={<PrivateRoute7><EditUsers /></PrivateRoute7>} />
        <Route path="new-user" element={<PrivateRoute7><NewUsers /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminUsersRoutes